// extracted by mini-css-extract-plugin
export default {"broadcast-edit__form":"EditBroadcastPopup_broadcast-edit__form__RPjwS","broadcast-edit__field-section":"EditBroadcastPopup_broadcast-edit__field-section__l2MHW"};